<div class="cards-popup">
  <header class="cards-popup-head">
    <div>
      <h2>Modifica visualizzazione schede</h2>
      <p>Scegli le quattro schede in primo piano nell'archivio.</p>
    </div>
    <button class="cards-popup-icon" type="button" (click)="closeDialog(1)" aria-label="Chiudi">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  </header>

  <div class="cards-popup-body">
    <div class="cards-popup-grid">
      @for (card of cards; track card.sort) {
        @if (card.id !== 0) {
          <app-card [obj_card]="card" [counter]="card.sort" [thumbnails]="thumbnails" [preview]="true"></app-card>
        } @else {
          <div class="cards-popup-empty">Spazio libero</div>
        }
      }
    </div>

    <form [formGroup]="cardsForm">
      <div class="cards-popup-fields">
        @for (slot of cardSlots; track slot.name) {
          <div class="cards-popup-field">
            <label [attr.for]="slot.name">{{ slot.label }}</label>
            <input
              [id]="slot.name"
              type="text"
              matInput
              [matAutocomplete]="auto"
              [formControlName]="slot.name"
              placeholder="Cerca una scheda"
              [class.is-invalid]="cardsForm.get(slot.name)?.hasError('invalidAutocomplete') && cardsForm.get(slot.name)?.value"
            >
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayArticleName" panelClass="cards-popup-autocomplete">
              @for (option of filteredArticles$[slot.index] | async; track option.id) {
                <mat-option [value]="option">{{ option.title }}</mat-option>
              }
            </mat-autocomplete>
            @if (cardsForm.get(slot.name)?.hasError('invalidAutocomplete') && cardsForm.get(slot.name)?.value) {
              <p class="cards-popup-error">Seleziona una scheda dalla lista.</p>
            }
          </div>
        }
      </div>

      <div class="cards-popup-actions">
        <button class="cards-popup-ghost" type="button" (click)="closeDialog(1)">Chiudi</button>
        <button class="cards-popup-save" type="button" (click)="saveCards()">Aggiorna</button>
      </div>
    </form>
  </div>
</div>
